export { default } from './ItemWidget';



// WEBPACK FOOTER //
// ./app/components/widgets/ItemWidget/index.js